import React from "react";
import { Image } from "react-bootstrap";

export default function ErrorState({ message = "Something went wrong. Please try again.", onRetry }) {
    return (
        <div style={styles.wrapper}>
            <div style={styles.card}>
                <div style={styles.icon}> <Image
                    src="/assets/images/icons/warning.svg"
                    className="svg-clone mr-2"
                /></div>
                <div style={styles.message}>{message}</div>

                {onRetry && (
                    <button style={styles.button} onClick={onRetry}>
                        Retry
                    </button>
                )}
            </div>
        </div>
    );
}

const styles = {
    wrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        padding: "20px",
    },
    card: {
        textAlign: "center",
        padding: "30px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        maxWidth: "320px",
        background: "#fff",
    },
    icon: {
        fontSize: "40px",
        marginBottom: "10px",
    },
    message: {
        fontSize: "16px",
        color: "#333",
        marginBottom: "20px",
        lineHeight: "1.4",
    },
    button: {
        padding: "10px 18px",
        borderRadius: "8px",
        border: "none",
        cursor: "pointer",
        fontSize: "14px",
        background: "#000",
        color: "#fff",
    },
};